(ns hypnos.dme.tile.field.patient-timezone
  "Field for patient timezone."
  (:require [clojure.string :as str]
            [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/timezone)]]
    [:div.field-body
     [:div.field.is-narrow
      [:div.control
       [:div.select.is-fullwidth
        [:select
         {:type      :text
          :disabled  disabled
          :value     (if-let [val (get-in @state [:patient :patient/timezone :value])]
                       (name val)
                       "")
          :on-change (fn [e]
                       (let [old-value (get-in @state [:patient :patient/timezone :value])
                             new-value (when-not (str/blank? (-> e .-target .-value))
                                         (keyword (str "timezone/" (-> e .-target .-value))))
                             changed?  (or (get-in @state [:patient :patient/timezone :dirty?])
                                           (not= new-value old-value))]
                         (swap! state assoc-in
                                [:patient :patient/timezone :value]
                                new-value)
                         (swap! state assoc-in
                                [:patient :patient/timezone :dirty?]
                                changed?)))
          :on-focus (fn [_]
                      (swap! state assoc-in
                             [:patient :patient/timezone :touched?]
                             true))}
         [:option {:value ""} ""]
         [:option {:key "est" :value "est"} (tr :ui.timezone/est)]
         [:option {:key "est5edt" :value "est5edt"} (tr :ui.timezone/est5edt)]
         [:option {:key "cst6cdt" :value "cst6cdt"} (tr :ui.timezone/cst6cdt)]
         [:option {:key "mst" :value "mst"} (tr :ui.timezone/mst)]
         [:option {:key "mst7mdt" :value "mst7mdt"} (tr :ui.timezone/mst7mdt)]
         [:option {:key "pst" :value "pst"} (tr :ui.timezone/pst)]
         [:option {:key "pst8pdt" :value "pst8pdt"} (tr :ui.timezone/pst8pdt)]
         [:option {:key "akdt" :value "akdt"} (tr :ui.timezone/akdt)]
         [:option {:key "hst" :value "hst"} (tr :ui.timezone/hst)]]]]
      (when-not disabled [:p.help (tr :ui.help/timezone)])]]]))
